import React, { useEffect, useState } from 'react';
import { ChakraProvider, useColorMode } from '@chakra-ui/react';
import Header from './Header';
import Footer from './Footer';
import Carousel from './Carousel';
import MainContent from './MainContent';
import '../styles/custom.css';

const Website = () => {
  const { setColorMode } = useColorMode();
  const [showCarousel, setShowCarousel] = useState(true);

  useEffect(() => {
    // Force light mode when the Website component is mounted
    setColorMode('light');
  }, [setColorMode]);

  return (
    <ChakraProvider>
      <Header />
      {showCarousel && <Carousel onEnd={() => setShowCarousel(false)} />}
      <MainContent />
      <Footer />
    </ChakraProvider>
  );
};

export default Website;